import React from "react";
import { BackgroundImage, HeaderComponent } from "../../FifthComponents";
import img from "../../fifthAssets/Images/contact-img.jpg"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import allPaths from "../../Config/paths"

const PediatricRehabilitation = (props) => {
    const { selectedLanguage } = props;
    const history = useHistory()
    return (
        <div>
            <BackgroundImage screenName={selectedLanguage?.txt_pediatric_rehabilitation_program} classForBg='fifth-des-pediatric-bg' {...props}/>
            <HeaderComponent title={selectedLanguage?.txt_pediatric_rehabilitation_program} lineClass='bg-gray' titleClass='color-blue' />
            <div className="fifth-des-contact-div">
                <div className="fifth-des-pediatric-text-div">
                    <p>
                        {selectedLanguage?.txt_pediatric_rehabilitation_program_details}
                    </p>
                    <h2>
                        {selectedLanguage?.txt_signs_and_symptoms}
                    </h2>
                    <p>
                        {selectedLanguage?.txt_childhood_disorders_treatable_with_physiotherapy}
                    </p>
                    <ul>
                        <li>
                            {selectedLanguage?.txt_cerebral_palsy}
                        </li>
                        <li>
                            {selectedLanguage?.txt_autism}
                        </li>
                        <li>
                            {selectedLanguage?.txt_down_syndrome}
                        </li>
                        <li>
                            {selectedLanguage?.txt_muscular_dystrophy_and_associated_disorders}
                        </li>
                    </ul>
                    <p>
                        <b>
                            {selectedLanguage?.txt_amsterdam_clinics}</b> {selectedLanguage?.txt_role_of_amsterdam_clinics}
                    </p>
                    <h2>
                        {selectedLanguage?.txt_care_path_includes}
                    </h2>
                    <ul>
                        <li>
                            {selectedLanguage?.txt_full_assessment_and_screening}
                        </li>
                        <li>
                            {selectedLanguage?.txt_comprehensive_diagnosis}
                        </li>
                        <li>
                            {selectedLanguage?.txt_second_opinion_dutch_expert}
                        </li>
                        <li>
                            {selectedLanguage?.txt_occupational_assessment}
                        </li>
                    </ul>
                </div>
                <div className="fifth-des-contact-img-div" onClick={() => history?.push(allPaths?.FIFHTAPPOINTMENT)}>
                    <img src={img} alt="" />
                </div>
            </div>
        </div>
    )
}
export default PediatricRehabilitation